<template slot="header" slot-scope="scope">
<div>
  <span><el-button style="float: right;margin-right: 30px;"  type="primary" @click="autSearch" size="small">查询</el-button><el-input  size="mini" placeholder="请输入企业名称"  v-model="searchName" @keyup.enter.native="autSearch"  style="width: 200px;float: right;margin-right: 10px;margin-bottom: 26px;margin-top: 3px;"/></span>
    <el-table :data="tableData" style="width: 100%" max-height="1000">
    <el-table-column fixed prop="eName" label="企业名称" min-width="150">
    </el-table-column>
    <el-table-column prop="eCode" label="企业信息用代码" min-width="180">
    </el-table-column>
      <el-table-column prop="contacts" label="联系人" min-width="80">
    </el-table-column>
      <el-table-column prop="tel" label="联系电话" min-width="120">
    </el-table-column>
    <el-table-column prop="updateTime" label="更新时间" min-width="180">
    </el-table-column>
      <el-table-column prop="state" label="状态" min-width="60" :formatter="stateFormat">
    </el-table-column>
    <el-table-column  label="操作">
      <template slot-scope="scope">
       <el-button @click="handleState(scope.$index,scope.row.id)" type="text" min-width="120" size="small">状态</el-button>
<router-link :to="{path:'/creditupdate',query:{pid:scope.row.id,currentPage:currentPage}}"  class="sidebar-nav-link" >
        <el-button type="text" size="small">查看</el-button>
          </router-link>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @prev-click="handleprevclick"
      @next-click="handlenextclick"
      :current-page="currentPage"
      :page-sizes="[15]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
<el-dialog class="cs" title="提示" :visible.sync="eventIsstate" width="450px" center>
            <div class="del-dialog-cnt">受理状态</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="setIsstate" >受理中</el-button>
                <el-button type="primary" @click="setNotstate" >待受理</el-button>
              <el-button type="primary" @click="setCompletestate" >完成</el-button>
            </span>
        </el-dialog>
</div>

</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'
export default {
  name: 'creditlist',
  data () {
    return {
      tableData: [],
      eventIsstate: false,
      isState: '',
      delId: '',
      delIndex: '',
      pageSize: 15,
      currentPage: 1,
      total: 0,
      pagenow: 1,
      searchName: ''
    }
  },
  created () {
    var that = this
    console.log(this)
    dataPost(rootPathssb.rootPath + '/admini/app/list').then(function (response) {
      that.checkSignin(response.data.result)
      that.total = response.data.info.total
      that.pagenow = response.data.info.currentPage
      console.log(response.data); console.log('bbb')
      that.tableData = response.data.info.list
    }).catch(function (error) {
      console.log(error)
      console.log('aaa')
    })
  }, // 页面加载时
  methods: {
    getPageDate (event) {
      let that = this
      let param = new URLSearchParams()
      param.append('serchname', that.searchName)
      param.append('pagenow', this.pagenow)
      dataPost(rootPathssb.rootPath + '/admini/app/list', param).then(function (response) {
        if (response.data.result === 1) {
          that.tableData = response.data.info.list
          console.log('cg')
        };console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    }, // 获取数据
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val// 获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
    }, // 每页个数变化
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.pagenow = val
      this.getPageDate()
    }, // 第几页
    handleprevclick (val) {
      this.currentPage = val - 1
      this.pagenow = val - 1
      this.getPageDate()
      console.log(this)
    }, // 上一页
    handlenextclick (val) {
      this.currentPage = val + 1
      this.pagenow = val + 1
      this.getPageDate()
    }, // 下一页
    handleState (index, id) {
      this.eventIsstate = true
      this.delId = id
      this.delIndex = index
    }, // 发布弹窗
    setIsstate () {
      let that = this
      this.eventIsstate = false
      this.isState = '1'
      let param = new URLSearchParams()
      param.append('state', this.isState)
      param.append('id', this.delId)
      console.log(this)

      dataPost(rootPathssb.rootPath + '/admini/app/state', param).then(function (response) {
        if (response.data.result === 1) {
          console.log('cg')
          var a = that.delIndex
          that.tableData[a].state = '1'
        };
      }).catch(function (error) {
        console.log(error)
      })
    },
    setNotstate () {
      let that = this
      this.eventIsstate = false
      this.isState = '0'
      let param = new URLSearchParams()
      param.append('state', this.isState)
      param.append('id', this.delId)
      dataPost(rootPathssb.rootPath + '/admini/app/state', param).then(function (response) {
        if (response.data.result === 1) {
          console.log('cg')
          var a = that.delIndex
          that.tableData[a].state = '0'
        };
      }).catch(function (error) {
        console.log(error)
      })
    },
    setCompletestate () {
      let that = this
      this.eventIsstate = false
      this.isState = '2'
      let param = new URLSearchParams()
      param.append('state', this.isState)
      param.append('id', this.delId)
      dataPost(rootPathssb.rootPath + '/admini/app/state', param).then(function (response) {
        if (response.data.result === 1) {
          console.log('cg')
          var a = that.delIndex
          that.tableData[a].state = '2'
        };
      }).catch(function (error) {
        console.log(error)
      })
    },

    stateFormat (row, column) {
      if (row.state === '0') {
        return '待受理'
      } if (row.state === '1') {
        return '受理中'
      } else {
        return '完成'
      }
    }, // 状态返回
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    }, // 登录判断
    autSearch () {
      var that = this
      console.log(this)
      let param = new URLSearchParams()
      param.append('serchname', that.searchName)
      dataPost(rootPathssb.rootPath + '/admini/app/list', param).then(function (response) {
        that.checkSignin(response.data.result)
        console.log(response.data); console.log('bbb')
        that.tableData = response.data.info.list
        that.total = response.data.info.total
        that.pagenow = response.data.info.currentPage
      }).catch(function (error) {
        console.log(error)
        console.log('aaa')
      })
    }// 搜索
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/creditlist.vue